import * as _ from "lodash-es";
import moment, { Moment } from "moment-timezone";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import shipstationLogo from "@assets/images/shipstation/shipstation-logo-white.png";
import ICreateShipmentDTO from "@models/DTO/ICreateShipmentDTO";
import ICreateShipmentFromPackingListDTO from "@models/DTO/ICreateShipmentFromPackingListDTO";
import IErrorDTO from "@models/DTO/IErrorDTO";
import IGetShipstationRatesDTO from "@models/DTO/IGetShipstationRatesDTO";
import IOnCreateShipmentDTO from "@models/DTO/IOnCreateShipmentDTO";
import IOnCreateShipmentFromPackingListDTO from "@models/DTO/IOnCreateShipmentFromPackingListDTO";
import EndpointsEnum from "@models/EndpointsEnum";
import IAddress from "@models/IAddress";
import INotification from "@models/INotification";
import IOrder from "@models/IOrder";
import IPacking_List from "@models/IPacking_List";
import IShipment from "@models/IShipment";
import IShipment_Group from "@models/IShipment_Group";
import ISupplierModel from "@models/ISupplierModel";
import IUserUI from "@models/IUserUI";
import NotificationLevelEnum from "@models/NotificationLevelEnum";
import NotificationPositionEnum from "@models/NotificationPositionEnum";
import ActivityIndicator from "@components/shared/ActivityIndicator/ActivityIndicator";
import AddressDisplay from "@components/shared/AddressDisplay/AddressDisplay";
import OwButton from "@components/shared/OwButton/OwButton";
import OwCheckbox from "@components/shared/OwCheckbox/OwCheckbox";
import OwDateInput from "@components/shared/OwDateInput/OwDateInput";
import OwInputWrapper from "@components/shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwSelectOption from "@components/shared/OwSelectOption/OwSelectOption";
import OwTextArea from "@components/shared/OwTextArea/OwTextArea";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwWeightSelector from "@components/shared/OwWeightSelector/OwWeightSelector";
import "./ShipmentPackageSidebar.scss";
import IPurchase_Order from "@models/IPurchase_Order";
import IUpdateShipmentDTO from "@models/DTO/IUpdateShipmentDTO";
import IOnCreateShipmentFromPurchaseOrderDTO from "@models/DTO/IOnCreateShipmentFromPurchaseOrderDTO";
import ICreateShipmentFromPurchaseOrderDTO from "@models/DTO/ICreateShipmentFromPurchaseOrderDTO";
import ShippingCarriersEnum from "@models/ShippingCarriersEnum";
import IOnGetSupplierShippingCarriersDTO from "@models/DTO/IOnGetSupplierShippingCarriersDTO";
import IGetSupplierShippingCarriersDTO from "@models/DTO/IGetSupplierShippingCarriersDTO";
import { Socket } from "socket.io-client";
import ICreateShipmentGroupAndShipmentFromOrderDTO from "@models/DTO/ICreateShipmentGroupAndShipmentFromOrderDTO";
import IOnCreateShipmentGroupAndShipmentFromOrderDTO from "@models/DTO/IOnCreateShipmentGroupAndShipmentFromOrderDTO";
import UIService from "@services/UIService";

type Props = {
    shipmentGroup?: IShipment_Group;
    purchaseOrder?: IPurchase_Order;
    shipment?: IShipment;
    order?: IOrder;
    cancel: () => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
    processedFn: any;
    onUpdateFn: any;
    packingList?: IPacking_List;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    currentView: string;
    shippingCarriers: any[];
    shippingStatuses: any[];
    shipment_date: Moment;
    hasShipstation: boolean;
    carriers: any[];
    shipping_carrier_id: any;
    tracking: string;
    shipment_status_id: any;
    disableCarriers: boolean;
    disableServiceType: boolean;
    disablePackageType: boolean;
    disableGetRates: boolean;
    disableWeights: boolean;
    activeGetCarriers: boolean;
    activeGetRates: boolean;
    activeGetPackageTypes: boolean;
    shipstationSelectedCarrier?: any;
    originalShipmentStatusId: any;
    shipstationServiceTypes?: any[];
    shipstationPackageTypes?: any[];
    shipstationCarriers?: any;
    note?: string;
    shipstation_packageType?: any;
    shipstation_serviceType?: any;
    shipstation_weight?: any;
    isTrackingDisabled?: boolean;
    width: number;
    height: number;
    length: number;
    activeSaveBtn: boolean;
    test_label: boolean;
    shipment_cost?: number;
};

class ShipmentPackageSidebar extends Component<Props, State> {
    static defaultProps = {};

    readonly state: State = {
        currentView: "create",
        shippingCarriers: [],
        shippingStatuses: [],
        shipment_date: moment(),
        hasShipstation: false,
        carriers: [],
        shipping_carrier_id: _.get(this.props.shipment, "shipping_carrier_id", null),
        tracking: _.get(this.props.shipment, "tracking", ""),
        shipment_status_id: _.get(this.props.shipment, "shipment_status_id", 7),
        disableCarriers: true,
        disableServiceType: true,
        disablePackageType: true,
        disableGetRates: true,
        disableWeights: true,
        activeGetCarriers: true,
        activeGetRates: false,
        activeGetPackageTypes: false,
        shipstationSelectedCarrier: {},
        originalShipmentStatusId: _.get(this.props.shipment, "shipment_status_id", null),
        width: 0,
        height: 0,
        length: 0,
        activeSaveBtn: false,
        test_label: false,
    };

    constructor(props: any) {
        super(props);

        // console.log('this.props.shipmentGroupGroup', this.props.shipmentGroup);

        this.state.shipstationServiceTypes = [];
        this.state.shipstationPackageTypes = [];
    }

    async componentDidMount() {
        let shipment_date = moment();

        if (!_.isNil(this.props.shipment)) {
            shipment_date = moment(this.props.shipment.shipment_date, "YYYY-MM-DD HH:mm:ss");
        }

        if (!shipment_date.isValid()) {
            shipment_date = moment();
        }

        const state: any = {
            isConnected: true,
            shipment_date,
        };

        if (!_.isNil(this.props.socket)) {
            this.props.socket.on(EndpointsEnum.ShipstationOnGetCarriers, this.onGetShipstationCarriers);
            this.props.socket.on(EndpointsEnum.ShipstationOnGetServicesForCarriers, this.onGetShipstationServicesForCarrier);
            this.props.socket.on(EndpointsEnum.ShipstationOnGetPackageTypesForCarriers, this.onGetShipstationPackageTypesForCarrier);
            this.props.socket.on(EndpointsEnum.ShipstationOnGetRates, this.onGetShipstationRates);
            this.props.socket.on(EndpointsEnum.ShipmentOnCreateShipment, this.onCreateShipment);
            this.props.socket.on(EndpointsEnum.ShipmentOnCreateShipmentFromPackingList, this.onCreateShipmentFromPackingList);
            this.props.socket.on(EndpointsEnum.ShipmentOnUpdateShipment, this.onUpdateShipment);
            this.props.socket.on(EndpointsEnum.ShipmentOnCreateShipmentFromPurchaseOrder, this.onCreateShipmentFromPurchaseOrder);
            this.props.socket.on(EndpointsEnum.Notify, this.notify);
            this.props.socket.on(EndpointsEnum.ShipmentOnGetSupplierShippingCarriers, this.onGetSupplierShippingCarriers);
            this.props.socket.on(
                EndpointsEnum.ShipmentOnCreateShipmentGroupAndShipmentFromOrder,
                this.onCreateShipmentGroupAndShipmentFromOrder
            );

            if (this.props.userModel.isSupplierUser) {
                const data = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                    offset: 0,
                    limit: 1000,
                };

                state.hasShipstation = this.hasShipstation(this.props.supplierModel);
                state.shippingStatuses = this._getStatus();
                state.shippingCarriers = this._getCarriers();

                if (this.state.hasShipstation) {
                    state.hideTracking = true;
                }

                if (this.props.supplierModel.only_custom_shipping_carriers) {
                    this.getSupplierShippingCarriers();
                }
            }

            if (this.props.userModel.isVendorSourceUser) {
                state.shippingStatuses = this._getStatus();
                state.shippingCarriers = this._getCarriers();
            }

            this.setState(state, () => {
                this.getShipstationCarriers();
            });
        }
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnGetCarriers, this.onGetShipstationCarriers);
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnGetServicesForCarriers, this.onGetShipstationServicesForCarrier);
        this.props.socket.removeListener(
            EndpointsEnum.ShipstationOnGetPackageTypesForCarriers,
            this.onGetShipstationPackageTypesForCarrier
        );
        this.props.socket.removeListener(EndpointsEnum.ShipstationOnGetRates, this.onGetShipstationRates);
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnCreateShipment, this.onCreateShipment);
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnCreateShipmentFromPackingList, this.onCreateShipmentFromPackingList);
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnUpdateShipment, this.onUpdateShipment);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnCreateShipmentFromPurchaseOrder, this.onCreateShipmentFromPurchaseOrder);
        this.props.socket.removeListener(EndpointsEnum.ShipmentOnGetSupplierShippingCarriers, this.onGetSupplierShippingCarriers);
        this.props.socket.removeListener(
            EndpointsEnum.ShipmentOnCreateShipmentGroupAndShipmentFromOrder,
            this.onCreateShipmentGroupAndShipmentFromOrder
        );
    }

    notify = () => {
        this.setState({
            activeSaveBtn: false,
        });
    };

    createShipmentGroupAndShipmentFromOrder = () => {
        if (this.props.order) {
            const { shipping_carrier_id, shipstation_carrierCode } = this.processShippingCarrierIdForSave();

            const payload: ICreateShipmentGroupAndShipmentFromOrderDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                orderGuid: this.props.order.guid,
                // @ts-expect-error
                shipment_date: this.state.shipment_date,
                shipping_carrier_id,
                shipstation_carrierCode,
                shipstation_serviceType: _.get(this.state, "shipstation_serviceType", undefined),
                shipstation_packageType: _.get(this.state, "shipstation_packageType", undefined),
                shipstation_weight: _.get(this.state, "shipstation_weight", undefined),
                shipment_status_id: this.state.shipment_status_id,
                tracking: this.state.tracking,
                note: this.state.note || "",
                width: this.state.width,
                height: this.state.height,
                length: this.state.length,
                test_label: this.state.test_label,
            };

            if (this.state.shipment_cost) {
                payload.shipment_cost = this.state.shipment_cost;
            }

            this.props.socket.emit(EndpointsEnum.ShipmentCreateShipmentGroupAndShipmentFromOrder, payload);

            this.setState({
                activeSaveBtn: true,
            });
        }
    };

    onCreateShipmentGroupAndShipmentFromOrder = (data: IOnCreateShipmentGroupAndShipmentFromOrderDTO) => {
        const notification: INotification = {
            message: "successfully_created_shipment",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        // this.props.processedFn(data);
        this.props.cancel();
    };

    createShipment = () => {
        const { shipping_carrier_id, shipstation_carrierCode } = this.processShippingCarrierIdForSave();

        const payload: ICreateShipmentDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            shipment_date: this.state.shipment_date,
            shipping_carrier_id,
            shipstation_carrierCode,
            shipstation_serviceType: _.get(this.state, "shipstation_serviceType", undefined),
            shipstation_packageType: _.get(this.state, "shipstation_packageType", undefined),
            shipstation_weight: _.get(this.state, "shipstation_weight", undefined),
            shipment_status_id: this.state.shipment_status_id,
            tracking: this.state.tracking,
            note: this.state.note || "",
            width: this.state.width,
            height: this.state.height,
            length: this.state.length,
            test_label: this.state.test_label,
        };

        if (this.state.shipment_cost) {
            payload.shipment_cost = this.state.shipment_cost;
        }

        if (this.props.shipmentGroup) {
            payload.shipmentGroupGuid = this.props.shipmentGroup.guid;
        }

        this.props.socket.emit(EndpointsEnum.ShipmentCreateShipment, payload);

        this.setState({
            activeSaveBtn: true,
        });
    };

    onCreateShipment = (data: IOnCreateShipmentDTO) => {
        this.props.processedFn(this.props.shipmentGroup, data);
        this.props.cancel();
    };

    createShipmentFromPackingList = () => {
        const { shipping_carrier_id, shipstation_carrierCode } = this.processShippingCarrierIdForSave();

        const payload: ICreateShipmentFromPackingListDTO = {
            packingListGuid: this.props.packingList!.guid,
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            shipment_date: this.state.shipment_date,
            shipping_carrier_id,
            create_in_shipstation: !!this.state.shipstation_packageType,
            shipstation_carrierCode,
            shipstation_serviceType: _.get(this.state, "shipstation_serviceType", undefined),
            shipstation_packageType: _.get(this.state, "shipstation_packageType", undefined),
            shipstation_weight: _.get(this.state, "shipstation_weight", undefined),
            shipment_status_id: this.state.shipment_status_id,
            tracking: this.state.tracking,
            note: this.state.note || "",
            width: this.state.width,
            height: this.state.height,
            length: this.state.length,
            test_label: this.state.test_label,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentCreateShipmentFromPackingList, payload);

        this.setState({
            activeSaveBtn: true,
        });
    };

    onCreateShipmentFromPackingList = (data: IOnCreateShipmentFromPackingListDTO) => {
        const notification: INotification = {
            message: "successfully_created_shipment",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.props.processedFn(data);
        this.props.cancel();
    };

    getSupplierShippingCarriers = () => {
        const payload: IGetSupplierShippingCarriersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.ShipmentGetSupplierShippingCarriers, payload);
    };

    onGetSupplierShippingCarriers = (data: IOnGetSupplierShippingCarriersDTO) => {
        this.setState({
            shippingCarriers: data.carriers,
        });
    };

    createShipmentFromPurchaseOrder = () => {
        if (this.props.purchaseOrder) {
            const { shipping_carrier_id, shipstation_carrierCode } = this.processShippingCarrierIdForSave();

            const payload: ICreateShipmentFromPurchaseOrderDTO = {
                isPartial: false,
                purchaseOrderGuid: this.props.purchaseOrder.guid,
                shipmentDate: this.state.shipment_date.format("YYYY-MM-DD"),
                shippingCarrierId: shipping_carrier_id,
                shipstationCarrierCode: shipstation_carrierCode,
                shipstationPackageType: _.get(this.state, "shipstation_packageType", undefined),
                shipstationServiceType: _.get(this.state, "shipstation_serviceType", undefined),
                weight: _.get(this.state, "shipstation_weight", undefined),
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                // @ts-expect-error
                shipment_date: this.state.shipment_date,
                create_in_shipstation: !!this.state.shipstation_packageType,
                shipment_status_id: this.state.shipment_status_id,
                tracking: this.state.tracking,
                note: this.state.note || "",
                width: this.state.width,
                height: this.state.height,
                length: this.state.length,
                test_label: this.state.test_label,
            };

            this.props.socket.emit(EndpointsEnum.ShipmentCreateShipmentFromPurchaseOrder, payload);

            this.setState({
                activeSaveBtn: true,
            });
        }
    };

    onCreateShipmentFromPurchaseOrder = (data: IOnCreateShipmentFromPurchaseOrderDTO) => {
        const notification: INotification = {
            message: "successfully_created_shipment",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.props.processedFn(data);
        this.props.cancel();
    };

    processShippingCarrierIdForSave = () => {
        let shipping_carrier_id = this.state.shipping_carrier_id;
        let shipstation_carrierCode;

        const shippingCarrier = _.find(this.state.shippingCarriers, (carrier) => {
            return parseInt(carrier.id) === parseInt(shipping_carrier_id);
        });

        if (shippingCarrier.shipstationCarrier) {
            shipping_carrier_id = undefined;
            shipstation_carrierCode = shippingCarrier.detail.code;
        } else {
            if (this.state.hasShipstation && this.props.shipmentGroup?.shipstation_order_id) {
                shipping_carrier_id = shipping_carrier_id - this.state.shipstationCarriers.length + 1; // remove the index change from shipstation carriers, but remember sql 1 based index
            }
        }

        return {
            shipping_carrier_id,
            shipstation_carrierCode,
        };
    };

    updateShipment = () => {
        if (!this.props.shipment) {
            return null;
        }

        const { shipping_carrier_id, shipstation_carrierCode } = this.processShippingCarrierIdForSave();

        const payload: Partial<IUpdateShipmentDTO> = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            shipmentGuid: this.props.shipment.guid,
            shipment_date: this.state.shipment_date.format("YYYY-MM-DD"),
            shipping_carrier_id,
            shipstation_carrierCode,
            shipstation_serviceType: _.get(this.state, "shipstation_serviceType", undefined),
            shipstation_packageType: _.get(this.state, "shipstation_packageType", undefined),
            shipstation_weight: _.get(this.state, "shipstation_weight", undefined),
            shipment_status_id: this.state.shipment_status_id,
            tracking: this.state.tracking,
            note: this.state.note,
        };

        if (this.props.shipmentGroup) {
            payload.shipmentGroupGuid = this.props.shipmentGroup.guid;
        }

        this.props.socket.emit(EndpointsEnum.ShipmentUpdateShipment, payload);

        this.setState({
            activeSaveBtn: true,
        });
    };

    onUpdateShipment = (data: any) => {
        this.props.onUpdateFn(this.props.shipmentGroup, data);
        this.props.cancel();
    };

    isShipstationCarrier = () => {
        if (_.isNil(this.state.shippingCarriers)) {
            return false;
        }

        return this.state.shippingCarriers[this.state.shipping_carrier_id].shipstationCarrier;
    };

    _getStatus = () => {
        const getStatus = this.showShipStationIntegration();

        if (getStatus) {
            return [{ name: "shipped", id: 7 }];
        } else {
            return [
                // { name: "Awaiting Payment", id: 1 },
                // { name: "Awaiting Fulfillment", id: 2 },
                // { name: "Awaiting Shipment", id: 3 },
                // { name: "Awaiting Pickup", id: 4 },
                // { name: "Partially Shipped", id: 5 },
                // { name: "Completed", id: 6 },
                { name: "shipped", id: 7 },
                // { name: "Cancelled", id: 8 },
                // { name: "Declined", id: 9 },
                // { name: "Refunded", id: 10 },
                // { name: "Verification Required", id: 11 },
                // { name: "Partially Refunded", id: 12 },
            ];
        }
    };

    getPackageTypeName = () => {
        const packageType = _.find(this.state.shipstationPackageTypes, (packageType) => {
            if (packageType.code === this.state.shipstation_packageType) {
                return packageType;
            }
        });

        return _.get(packageType, "name", "");
    };

    getServiceTypeName = () => {
        const serviceType = _.find(this.state.shipstationServiceTypes, (serviceType) => {
            if (serviceType.code === this.state.shipstation_serviceType) {
                return serviceType;
            }
        });

        return _.get(serviceType, "name", "");
    };

    getShippingStatusById = (id: any) => {
        const statuses = this._getStatus();

        const status = _.find(statuses, (status, index) => {
            return status.id === parseInt(id);
        });

        return _.get(status, "name", "");
    };

    getCarrierById = (id: any) => {
        const carrier = _.find(this.state.shippingCarriers, (carrier, index) => {
            return carrier.id === parseInt(id);
        });

        return _.get(carrier, "name", "");
    };

    _getCarriers = () => {
        const getCarriers = this.showShipStationIntegration();

        if (getCarriers) {
            return [];
        } else {
            if (!this.props.supplierModel.only_custom_shipping_carriers) {
                return [
                    { name: "UPS", id: ShippingCarriersEnum.UPS },
                    { name: "FedEx", id: ShippingCarriersEnum.FEDEX },
                    { name: "USPS", id: ShippingCarriersEnum.USPS },
                    { name: "TNT", id: ShippingCarriersEnum.TNT },
                    { name: "DHL", id: ShippingCarriersEnum.DHL },
                    { name: "3PL", id: ShippingCarriersEnum.THREEPL },
                    { name: "Local", id: ShippingCarriersEnum.LOCAL },
                ];
            }
        }
    };

    changeView = (currentView: string) => {
        this.setState({
            currentView,
        });
    };

    hasShipstation = (_supplierModel: any) => {
        let hasShipstation;

        const supplierModel = !_.isNil(_supplierModel) ? _supplierModel : this.props.supplierModel;

        if (!_.isNil(supplierModel) && !_.isNil(supplierModel.Supplier_Integration)) {
            hasShipstation = _.get(supplierModel.Supplier_Integration, "has_shipstation", 0);

            if (_.isString(hasShipstation)) {
                hasShipstation = parseInt(hasShipstation);
            }
        }

        return hasShipstation;
    };

    shipstationIntegrated = () => {
        return this.state.hasShipstation && this.props.shipmentGroup?.shipstation_order_id ? (
            <div className="pb-2">
                <img src={shipstationLogo} height="21" />
            </div>
        ) : null;
    };

    shipstationGetCreateServiceType = () => {
        return (
            <OwSelectOption
                isDisabled={this.state.disableServiceType}
                fn={this.handleChange}
                options={this.state.shipstationServiceTypes}
                valueProp={"code"}
                titleProp={"name"}
                selectedOption={this.state}
                selectedOptionProp={"shipstation_serviceType"}
                name={"shipstation_serviceType"}
                showBlankFirst={true}
            />
        );
    };

    shipstationGetCreatePackageType = () => {
        return (
            <OwSelectOption
                isDisabled={this.state.disablePackageType}
                selectedOption={this.state}
                selectedOptionProp={"shipstation_packageType"}
                options={this.state.shipstationPackageTypes}
                valueProp={"code"}
                titleProp={"name"}
                fn={this.handleChange}
                name={"shipstation_packageType"}
                showBlankFirst={true}
            />
        );
        // return (<select className="form-control" name="shipstation_packageType" onChange={this.handleSupplierChange} value={this.state.shipstation_packageType} disabled={this.state.isTrackingDisabled}>
        //   <option>Select Package Type</option>
        //   {this.state.shipstationPackageTypes.map((packageType, index) => {
        //     return <option key={index} value={packageType.code}>{packageType.name}</option>
        //   })}
        // </select>);
    };

    shipstationGetCreateWeight = () => {
        return (
            <OwWeightSelector
                weight={this.state.shipstation_weight}
                disabled={this.state.disableWeights}
                onChange={this.handleChange}
                name={"shipstation_weight"}
            />
        );
    };

    shipstationGetRatesButton = () => {
        return (
            <OwButton
                disabled={this.state.disableGetRates}
                active={this.state.activeGetRates}
                fn={this.getShipstationRates}
                title={"get_rates"}
                className={"btn-primary me-2"}
            />
        );
    };

    showShipStationIntegration = (): boolean => {
        let showIntegration = false;

        if (this.state.hasShipstation) {
            if (this.props.packingList) {
                showIntegration = true;
            } else if (this.props.purchaseOrder) {
                showIntegration = true;
            } else if (this.props.shipmentGroup) {
                if (this.props.shipmentGroup.shipstation_order_id) {
                    showIntegration = true;
                }
            } else {
                if (this.props.userModel.isSupplierUser) {
                    showIntegration = true;
                }
            }
        }

        return showIntegration;
    };

    shipstationCreateIntegration = () => {
        const showIntegration = this.showShipStationIntegration();

        if (!showIntegration) {
            return null;
        }

        if (
            !_.isNil(this.state.shipping_carrier_id) &&
            !_.isNil(this.state.shippingCarriers[this.state.shipping_carrier_id]) &&
            !this.state.shippingCarriers[this.state.shipping_carrier_id].shipstationCarrier
        ) {
            return null;
        }

        const serviceType = this.shipstationGetCreateServiceType();
        const packageType = this.shipstationGetCreatePackageType();
        const weight = this.shipstationGetCreateWeight();
        const getRatesButton = this.shipstationGetRatesButton();

        return (
            <div>
                <div className="mb-4">
                    <div>
                        <OwTitle title={"package"} tag={"h5"} className={"d-inline-flex me-2"} />
                        <ActivityIndicator active={this.state.activeGetPackageTypes} />
                    </div>
                    {packageType}
                </div>
                <div className="mb-4">
                    <OwTitle title={"weight"} tag={"h5"} />
                    {weight}
                </div>
                <div className={"mb-4"}>
                    <OwTitle title={"dimensions"} tag={"h5"} />
                    <div>
                        <OwLabel title={"length"} noBottomMargin={true} />
                        <OwInputWrapper type={"number"} fn={this.handleChange} name={"length"} value={this.state.length} onWheelFn={UIService.stopScrollWheel}/>
                    </div>
                    <div>
                        <OwLabel title={"width"} noBottomMargin={true} />
                        <OwInputWrapper type={"number"} fn={this.handleChange} name={"width"} value={this.state.width} onWheelFn={UIService.stopScrollWheel}/>
                    </div>

                    <div>
                        <OwLabel title={"height"} noBottomMargin={true} />
                        <OwInputWrapper type={"number"} fn={this.handleChange} name={"height"} value={this.state.height} onWheelFn={UIService.stopScrollWheel}/>
                    </div>
                </div>
                <div className="mb-4">{getRatesButton}</div>
                <div className="mb-4">
                    <OwTitle title={"service_type"} tag={"h5"} />
                    {serviceType}
                </div>
            </div>
        );
    };

    /**
     * START SHIPSTATION SPECIFIC FUNCTIONS
     */
    getShipstationCarriers = () => {
        const getCarriers = this.showShipStationIntegration();

        if (!getCarriers) {
            this.setState({
                activeGetCarriers: false,
                disableCarriers: false,
            });
            return;
        } else {
            const data = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
            };

            this.props.socket.emit(EndpointsEnum.ShipstationGetCarriers, data);
        }
    };

    onGetShipstationCarriers = (data: any) => {
        const shipstationCarriers = _.map(data.carriers, (shipstationCarrier, index) => {
            return {
                name: `${shipstationCarrier.name} [SHIPSTATION]`,
                id: index,
                shipstationCarrier: true,
                detail: shipstationCarrier,
            };
        });

        let shipping_carrier_id;

        if (!_.isNil(this.state.shipping_carrier_id) && this.state.shipping_carrier_id > 0) {
            shipping_carrier_id = this.state.shipping_carrier_id + shipstationCarriers.length - 1;
        }

        const carriers: any[] = _.map(this._getCarriers(), (carrier, index) => {
            const carrierIndex = shipstationCarriers.length + index;

            return {
                name: carrier.name,
                id: carrierIndex,
                shipstationCarrier: false,
            };
        });

        const allCarriers = shipstationCarriers.concat(carriers);

        console.log("All Carriers:", allCarriers);

        this.setState({
            shippingCarriers: allCarriers,
            shipstationCarriers: data.carriers,
            shipping_carrier_id,
            activeGetCarriers: false,
            disableCarriers: false,
        });
    };

    selectShippingCarrier = () => {};

    getShipstationRates = () => {
        if (!this.state.hasShipstation) {
            return;
        }

        this.setState(
            {
                activeGetRates: true,
            },
            () => {
                let shipTo: IAddress;

                if (this.props.shipmentGroup && !this.props.packingList) {
                    shipTo = this.props.shipmentGroup.Ship_To!;
                } else {
                    if (this.props.packingList) {
                        const orders: IOrder[] = this.props.packingList.Orders ? this.props.packingList.Orders : [{} as IOrder];
                        const firstOrder = orders[0];

                        shipTo = _.get(firstOrder, "Ship_To", this.props.packingList.Vendor?.Ship_To || ({} as IAddress));
                    } else if (this.props.purchaseOrder && this.props.purchaseOrder.Order) {
                        const order: IOrder = this.props.purchaseOrder.Order;
                        shipTo = _.get(order, "Ship_To", this.props.purchaseOrder?.Ship_To || ({} as IAddress));
                    } else if (this.props.order) {
                        shipTo = _.get(this.props.order, "Ship_To", {} as IAddress);
                    } else {
                        return null;
                    }
                }

                const data: IGetShipstationRatesDTO = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                    shipstation_carrierCode: this.state.shipstationSelectedCarrier.detail.code,
                    // shipstation_serviceType: this.state.shipstationServiceTypes[this.state.shipstation_serviceType].code,
                    shipstation_packageType: this.state.shipstation_packageType,
                    shipstation_weight: this.state.shipstation_weight,
                    fromPostalCode: this.props.supplierModel.Ship_To.postal_code,
                    toPostalCode: shipTo.postal_code,
                    width: Number(this.state.width),
                    height: Number(this.state.height),
                    length: Number(this.state.length),
                };

                this.props.socket.emit("getShipstationRates", data);
            }
        );
    };

    onGetShipstationRates = (data: any) => {
        const rates = _.map(data.rates, (rate, index) => {
            const totalShipmentCost = rate.shipmentCost + rate.otherCost;

            const shipmentCost = totalShipmentCost.toFixed(2);
            const currencyPrefix = "$";

            return {
                name: `${rate.serviceName} - ${currencyPrefix}${shipmentCost}`,
                code: rate.serviceCode,
                id: index,
            };
        });

        let shipstationServiceTypes = rates;

        // Endicia doesn't return any service types, it comes across when selecting the carrier type.
        if (!shipstationServiceTypes.length && this.state.shipstationServiceTypes) {
            shipstationServiceTypes = this.state.shipstationServiceTypes;
        }

        this.setState({
            shipstationServiceTypes,
            disableServiceType: false,
            activeGetRates: false,
        });
    };

    getShipstationPackageTypesForCarrier = (shipstationCarrierDetail: any) => {
        if (!this.state.hasShipstation) {
            return;
        }

        this.setState(
            {
                activeGetPackageTypes: true,
            },
            () => {
                const data = {
                    userGuid: this.props.userModel.guid,
                    userToken: this.props.userModel.token,
                    supplierGuid: this.props.supplierModel.guid,
                    shipstation_carrierCode: shipstationCarrierDetail.code,
                    shipstation_serviceType: this.state.shipstation_serviceType,
                };

                this.props.socket.emit("getShipstationPackageTypesForCarrier", data);
            }
        );
    };

    onGetShipstationPackageTypesForCarrier = (data: any) => {
        this.setState({
            shipstationPackageTypes: data.packageTypes,
            disablePackageType: false,
            activeGetPackageTypes: false,
        });
    };

    getShipstationServicesForCarrier = (shipstationCarrierDetail: any) => {
        if (!this.state.hasShipstation) {
            return;
        }

        const data = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipstation_carrierCode: shipstationCarrierDetail.code,
        };

        this.props.socket.emit("getShipstationServicesForCarrier", data);
    };

    onGetShipstationServicesForCarrier = (data: any) => {
        const shipstationServiceTypes = data.serviceTypes;

        this.setState({
            shipstationServiceTypes,
        });
    };

    /**
     * END SHIPSTATION SPECIFIC FUNCTIONS
     */

    getHeaderTitle = () => {
        let header = "add_shipment";

        if (!_.isNil(this.props.shipment)) {
            if (this.state.originalShipmentStatusId >= 4) {
                header = "review_shipment";
            } else {
                header = "edit_shipment";
            }
        }

        return header;
    };

    handleDateChange = (date: any) => {
        console.log("Handle Date Change", date);
        this.setState({
            shipment_date: date,
        });
    };

    handleChange = (e: any) => {
        if (e?.target) {
            const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
            const name = e.target.name;

            let isTrackingDisabled = this.state.isTrackingDisabled;
            const shipstationSelectedCarrier = this.state.shipstationSelectedCarrier;

            const state: any = {
                [name]: value,
                isTrackingDisabled,
            };

            if (name === "shipping_carrier_id") {
                if (this.state.hasShipstation) {
                    // check to see if its a shipstation carrier.
                    const selectedCarrier = _.find(this.state.shippingCarriers, (carrier) => {
                        return Number(carrier.id) === Number(value);
                    });

                    state.shipstationSelectedCarrier = selectedCarrier;
                    state.shipping_carrier_id = selectedCarrier.id;

                    if (!_.isNil(selectedCarrier.detail)) {
                        this.getShipstationServicesForCarrier(selectedCarrier.detail);
                        this.getShipstationPackageTypesForCarrier(selectedCarrier.detail);
                        // if it is, lookup into the stored carrier details, and retrieve the services based off of the carrier code property.
                    }

                    isTrackingDisabled = false;
                } else {
                    isTrackingDisabled = false;
                }
            } else if (name === "shipstation_packageType") {
                state.disableWeights = false;
                state.disableGetRates = false;
            }

            this.setState(state);
        }
    };

    getShipmentGroupDetail = () => {
        let firstOrderName: any = _.get(this.props.shipmentGroup, "Orders[0].name");
        let shipTo = _.get(this.props.shipmentGroup, "Ship_To");

        if (!shipTo) {
            if (this.props.purchaseOrder) {
                if (this.props.purchaseOrder.Order) {
                    firstOrderName = _.get(this.props.purchaseOrder.Order, "name");
                    shipTo = _.get(this.props.purchaseOrder.Order, "Ship_To");
                }
            }

            if (this.props.order) {
                firstOrderName = _.get(this.props.order, "name");
                shipTo = _.get(this.props.order, "Ship_To");
            }
        }

        if (this.props.packingList) {
            if (!firstOrderName) {
                firstOrderName = (this.props.packingList.Orders || []).map((order) => {
                    return <div key={order.guid}>{order.name}</div>;
                });
            }

            if (!shipTo) {
                const orders: IOrder[] = this.props.packingList.Orders ? this.props.packingList.Orders : [{} as IOrder];
                const firstOrder = orders[0];

                shipTo = _.get(firstOrder, "Ship_To", this.props.packingList.Vendor?.Ship_To || ({} as IAddress));
            }
        }

        return (
            <div>
                <table>
                    <tbody className={"align-top"}>
                        <tr>
                            <th>
                                <OwLabel title={"order"} />
                            </th>
                            <td>{firstOrderName}</td>
                        </tr>
                        <tr>
                            <th>
                                <OwLabel title={"ship_to"} className={"me-4"} />
                            </th>
                            <td>
                                <AddressDisplay address={shipTo} prefix={""} showName={true} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr />
            </div>
        );
    };

    renderCreateView() {
        // const selectedOrderIds = this.formatSelectedOrders();

        const header = this.getHeaderTitle();

        return (
            <div className="CreateShipmentSidebar p-3 d-flex flex-column " style={{ height: "100%", overflowY: "scroll" }}>
                <div>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.props.cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fas fa-truck"} title={header} />
                    <hr />
                    {this.shipstationIntegrated()}
                </div>

                {this.getShipmentGroupDetail()}

                <div>
                    <div>
                        <div className="mb-4">
                            <h5>
                                <FormattedMessage id="ship_date" defaultMessage="Ship Date" description="Ship Date Title" />
                            </h5>

                            <OwDateInput selectedDate={this.state.shipment_date} fn={this.handleDateChange} />
                        </div>

                        <div className="mb-4">
                            {this.state.hasShipstation && this.props.shipmentGroup?.shipstation_order_id ? <div className="" /> : null}
                            <div>
                                <OwTitle title={"carrier"} tag={"h5"} className={"d-inline-flex me-2"} />
                                <ActivityIndicator active={this.state.activeGetCarriers} />
                            </div>
                            <div>
                                {this.state.shipping_carrier_id}
                                <OwSelectOption
                                    selectedOption={this.state}
                                    selectedOptionProp={"shipping_carrier_id"}
                                    options={this.state.shippingCarriers}
                                    valueProp={"id"}
                                    titleProp={"name"}
                                    fn={this.handleChange}
                                    name={"shipping_carrier_id"}
                                    isDisabled={this.state.activeGetCarriers}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>

                        {this.shipstationCreateIntegration()}

                        {this.props.shipmentGroup?.shipstation_order_id ? null : (
                            <div className={"mb-4 "}>
                                <h5>
                                    <FormattedMessage id="tracking_code" defaultMessage="Tracking Code" description="Tracking Code Title" />
                                </h5>
                                <div>
                                    <OwInputWrapper
                                        name={"tracking"}
                                        placeholder={"tracking_code"}
                                        fn={this.handleChange}
                                        disabled={this.state.isTrackingDisabled}
                                        value={this.state.tracking}
                                    />
                                </div>
                            </div>
                        )}

                        {this.props.shipmentGroup?.shipstation_order_id ? null : (
                            <div className={"mb-4"}>
                                <h5>
                                    <FormattedMessage id="shipment_cost" defaultMessage="Shipment Cost" description="Shipment Cost Title" />
                                </h5>
                                <div>
                                    <OwInputWrapper
                                        name={"shipment_cost"}
                                        placeholder={"shipment_cost"}
                                        fn={this.handleChange}
                                        value={this.state.shipment_cost}
                                    />
                                </div>
                            </div>
                        )}

                        <div className="mb-4">
                            <h5>
                                <FormattedMessage id="status" defaultMessage="Status" description="Status Title" />
                            </h5>
                            <div>
                                <OwSelectOption
                                    name={"shipment_status_id"}
                                    fn={this.handleChange}
                                    options={this.state.shippingStatuses}
                                    titleProp={"name"}
                                    valueProp={"id"}
                                    selectedOption={this.state}
                                    selectedOptionProp={"shipment_status_id"}
                                    translateTitle={true}
                                    autoSelectSingleOption={true}
                                    // showBlankFirst={this.state.shippingStatuses.length !== 1}
                                    emitOnLoad={this.state.shippingStatuses.length === 1}
                                    hasSelectedOptionProp={true}
                                />
                            </div>
                        </div>

                        <div className="mb-4">
                            <h5>
                                <FormattedMessage id="note" defaultMessage="Note" description="Note Title" />
                            </h5>
                            <div>
                                <OwTextArea placeholder={"note"} value={this.state.note} fn={this.handleChange} name={"note"} />
                            </div>
                        </div>

                        {this.props.supplierModel.Supplier_Integration.has_shipstation ? (
                            <div>
                                <OwCheckbox
                                    label={"test_label"}
                                    fn={this.handleChange}
                                    name={"test_label"}
                                    truthyVal={true}
                                    falsyVal={false}
                                    checked={this.state.test_label}
                                />
                            </div>
                        ) : null}

                        <div className="mb-4">
                            <OwButton
                                className={"btn-primary me-3"}
                                leftIconClass={"fas fa-list"}
                                title={"review"}
                                fn={() => {
                                    this.changeView("review");
                                }}
                            />

                            {this.props.shipmentGroup && this.props.shipmentGroup.guid ? null : (
                                <OwButton
                                    className={"btn-danger"}
                                    leftIconClass={"fas fa-eraser"}
                                    title={"clear"}
                                    // fn={this.resetShipment}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderReviewView() {
        const header = this.getHeaderTitle();

        const AWAITING_PICKUP_STATUS = 4;

        const buttons_visible =
            !_.isNil(this.props.shipmentGroup) &&
            this.props.shipmentGroup.guid &&
            this.state.originalShipmentStatusId > AWAITING_PICKUP_STATUS;

        return (
            <div className="CreateShipmentSidebar p-3">
                <div>
                    <div className="text-end">
                        <button className="btn btn-danger" onClick={this.props.cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle leftIconName={"fas fa-truck"} title={header} />
                    {/*<h2><i className="fas fa-truck"></i> {header}</h2>*/}
                    <hr />
                    {this.shipstationIntegrated()}
                </div>

                {this.getShipmentGroupDetail()}

                <div className="review-section">
                    <div>
                        <b>
                            <FormattedMessage id="ship_date" defaultMessage="Ship Date" description="Ship Date Title" />
                        </b>
                        <div className="ms-3">{this.state.shipment_date.format("MM-DD-YYYY")}</div>
                    </div>
                    <div>
                        <b>
                            <FormattedMessage id="carrier" defaultMessage="Carrier" description="Carrier Title" />
                        </b>
                        <div className="ms-3">{this.getCarrierById(this.state.shipping_carrier_id)}</div>
                    </div>
                    <div className={this.state.shipstationSelectedCarrier.shipstationCarrier ? "" : "d-none"}>
                        <div className={"mb-3"}>
                            <b>
                                <OwLabel title={"package"} />
                            </b>
                            <div className="ms-3">{this.getPackageTypeName()}</div>
                        </div>

                        <div className={"mb-3"}>
                            <b>
                                <OwLabel title={"weight"} />
                            </b>
                            <div className="ms-3">{this.state.shipstation_weight} Lbs.</div>
                        </div>

                        <div className={"mb-3"}>
                            <b>
                                <OwLabel title={"service"} />
                            </b>
                            <div className="ms-3">{this.getServiceTypeName()}</div>
                        </div>
                    </div>
                    <div className={this.state.shipstationSelectedCarrier.shipstationCarrier ? "d-none" : ""}>
                        <b>
                            <FormattedMessage id="tracking" defaultMessage="Tracking" description="Tracking Title" />
                        </b>
                        <div className="ms-3">{this.state.tracking}</div>
                    </div>
                    <div className={this.state.shipstationSelectedCarrier.shipstationCarrier ? "d-none" : ""}>
                        <b>
                            <FormattedMessage id="cost" defaultMessage="Cost" description="Cost Title" />
                        </b>
                        <div className="ms-3">{this.state.shipment_cost}</div>
                    </div>
                    <div>
                        <b>
                            <FormattedMessage id="status" defaultMessage="Status" description="Status Title" />
                        </b>
                        <div className="ms-3">{this.getShippingStatusById(this.state.shipment_status_id)}</div>
                    </div>

                    <div>
                        <b>
                            <FormattedMessage id="note" defaultMessage="Note" description="Note Title" />
                        </b>

                        <div className="ms-3">
                            {this.state.note}
                            <br />
                        </div>
                    </div>
                    <div className={"mb-4 "}>
                        <OwButton
                            className={"btn-danger me-3"}
                            leftIconClass={"fas fa-pencil"}
                            title={"edit"}
                            fn={() => {
                                this.changeView("create");
                            }}
                        />

                        {!_.isNil(this.props.shipmentGroup) || this.props.purchaseOrder || this.props.order ? (
                            <OwButton
                                active={this.state.activeSaveBtn}
                                disableOnActive={true}
                                leftIconClass={"fas fa-save"}
                                title={"save"}
                                fn={() => {
                                    if (!this.props.packingList && !this.props.purchaseOrder && !this.props.order) {
                                        if (_.get(this.props.shipment, "guid", false)) {
                                            this.updateShipment();
                                        } else {
                                            this.createShipment();
                                        }
                                    } else if (this.props.purchaseOrder) {
                                        this.createShipmentFromPurchaseOrder();
                                    } else if (this.props.order) {
                                        this.createShipmentGroupAndShipmentFromOrder();
                                    } else {
                                        this.createShipmentFromPackingList();
                                    }
                                }}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.state.currentView === "create" ? this.renderCreateView() : null}
                {this.state.currentView === "review" ? this.renderReviewView() : null}
            </React.Fragment>
        );
    }
}

export default ShipmentPackageSidebar;
